import React, { FC, ReactElement, ReactNode } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import AppModal from './app-modal/AppModal';

type ConfirmationModalProps = {
  show: boolean;
  title: ReactNode;
  body: ReactNode;
  buttonPositive: ReactNode;
  buttonNegative: ReactNode;
  disableButton?: boolean;
  onPositive: () => void;
  onNegative: () => void;
};

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  show,
  title,
  body,
  buttonPositive,
  buttonNegative,
  onPositive,
  onNegative,
  disableButton,
}: ConfirmationModalProps): ReactElement => {
  return (
    <AppModal show={show} onHide={() => onNegative()} dialogClassName="modal-dialog-centered">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" style={{ marginRight: 'auto' }} onClick={() => onNegative()} disabled={disableButton}>
          {buttonNegative}
        </Button>
        <Button onClick={() => onPositive()} variant="primary" disabled={disableButton}>
          {buttonPositive}
        </Button>
      </Modal.Footer>
    </AppModal>
  );
};

export default ConfirmationModal;
